export default __webpack_public_path__ + "static/media/meh-o.a5ce395b.svg";